// API Configuration
const API_CONFIG = {
  // Base URL for the PHP backend
  BASE_URL: "https://rankoapi.buclocate.com",

  // Alternative base URLs (for reference)
  // BASE_URL: 'http://localhost:8080/backend-php',  // Local development
  // BASE_URL: 'http://localhost/backend-php',       // Local Apache

  // API endpoints
  ENDPOINTS: {
    AUTH_LOGIN: "/api/auth/login",
    USERS: "/api/users",
    CROPS: "/api/crops",
    TREES: "/api/trees",
    TREE_BY_ID: (id) => `/api/trees/${id}`,
    CLIENTS: "/api/clients",
    CLIENT_BY_ID: (id) => `/api/clients/${id}`,
    CLIENT_TREES: (clientId) => `/api/clients/${clientId}/trees`,
    CLIENT_CROPS: (clientId) => `/api/clients/${clientId}/crops`,
    // Marketplace endpoints
    PRODUCTS: "/api/products",
    PRODUCT_BY_ID: (id) => `/api/products/${id}`,
    PRODUCT_CATEGORIES: "/api/products/categories",
    HEALTH: "/api/health",
  },
};

// Helper function to get full URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Export individual endpoint URLs
export const API_URLS = {
  AUTH_LOGIN: getApiUrl(API_CONFIG.ENDPOINTS.AUTH_LOGIN),
  USERS: getApiUrl(API_CONFIG.ENDPOINTS.USERS),
  CROPS: getApiUrl(API_CONFIG.ENDPOINTS.CROPS),
  TREES: getApiUrl(API_CONFIG.ENDPOINTS.TREES),
  TREE_BY_ID: (id) => getApiUrl(API_CONFIG.ENDPOINTS.TREE_BY_ID(id)),
  CLIENTS: getApiUrl(API_CONFIG.ENDPOINTS.CLIENTS),
  CLIENT_BY_ID: (id) => getApiUrl(API_CONFIG.ENDPOINTS.CLIENT_BY_ID(id)),
  CLIENT_TREES: (clientId) =>
    getApiUrl(API_CONFIG.ENDPOINTS.CLIENT_TREES(clientId)),
  CLIENT_CROPS: (clientId) =>
    getApiUrl(API_CONFIG.ENDPOINTS.CLIENT_CROPS(clientId)),
  // Marketplace URLs
  PRODUCTS: getApiUrl(API_CONFIG.ENDPOINTS.PRODUCTS),
  PRODUCT_BY_ID: (id) => getApiUrl(API_CONFIG.ENDPOINTS.PRODUCT_BY_ID(id)),
  PRODUCT_CATEGORIES: getApiUrl(API_CONFIG.ENDPOINTS.PRODUCT_CATEGORIES),
  HEALTH: getApiUrl(API_CONFIG.ENDPOINTS.HEALTH),
};

export default API_CONFIG;
